var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "v-details-form" },
    [
      _c("div", { staticClass: "form__heading" }, [
        _c("h2", { staticClass: "form__title" }, [
          _vm._v(_vm._s(_vm.businessTitle))
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form__block" }, [
        _vm.website == "athome"
          ? _c("ul", { staticClass: "form__list" }, [
              _c(
                "li",
                { staticClass: "form__item" },
                [
                  _c("v-radios-public", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required|make_choice",
                        expression: "`required|make_choice`"
                      }
                    ],
                    attrs: {
                      name: "business_registration",
                      options: _vm.businessRadioOptions,
                      value: _vm.business_form_state,
                      label: _vm.businessLabel
                    },
                    on: { input: _vm.triggerBusinessForm }
                  })
                ],
                1
              )
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _vm.business_form_state === "1"
        ? _c("div", { attrs: { id: "business-form" } }, [
            _vm.website == "staffhousing"
              ? _c("input", {
                  attrs: {
                    type: "hidden",
                    name: "business_registration",
                    value: "1"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _c(
              "ul",
              { staticClass: "form__list" },
              [
                _c(
                  "li",
                  { staticClass: "form__item" },
                  [
                    _c("v-textfield-public", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "`required`"
                        }
                      ],
                      attrs: {
                        label: _vm.companyName,
                        name: _vm.companyNameInput
                      },
                      model: {
                        value: _vm.company_value,
                        callback: function($$v) {
                          _vm.company_value = $$v
                        },
                        expression: "company_value"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.website == "staffhousing"
                  ? [
                      _c(
                        "li",
                        { staticClass: "form__item" },
                        [
                          _c("v-textfield-public", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "alpha_spaces_dash",
                                expression: "`alpha_spaces_dash`"
                              }
                            ],
                            attrs: {
                              label:
                                (_vm.locales &&
                                  _vm.locales.subscriptions &&
                                  _vm.locales.subscriptions.contact_person +
                                    " ") + _vm.subscriptionsFirstName,
                              name: _vm.subscriptionsFirstNameInput
                            },
                            model: {
                              value: _vm.subscriptions_first_name_value,
                              callback: function($$v) {
                                _vm.subscriptions_first_name_value = $$v
                              },
                              expression: "subscriptions_first_name_value"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "li",
                        { staticClass: "form__item" },
                        [
                          _c("v-textfield-public", {
                            attrs: {
                              label:
                                (_vm.locales &&
                                  _vm.locales.subscriptions &&
                                  _vm.locales.subscriptions.contact_person +
                                    " ") + _vm.subscriptionsMiddleName,
                              name: _vm.subscriptionsMiddleNameInput
                            },
                            model: {
                              value: _vm.subscriptions_middle_name_value,
                              callback: function($$v) {
                                _vm.subscriptions_middle_name_value = $$v
                              },
                              expression: "subscriptions_middle_name_value"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "li",
                        { staticClass: "form__item" },
                        [
                          _c("v-textfield-public", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "alpha_spaces_dash",
                                expression: "`alpha_spaces_dash`"
                              }
                            ],
                            attrs: {
                              label:
                                (_vm.locales &&
                                  _vm.locales.subscriptions &&
                                  _vm.locales.subscriptions.contact_person +
                                    " ") + _vm.subscriptionsLastName,
                              name: _vm.subscriptionsLastNameInput
                            },
                            model: {
                              value: _vm.subscriptions_last_name_value,
                              callback: function($$v) {
                                _vm.subscriptions_last_name_value = $$v
                              },
                              expression: "subscriptions_last_name_value"
                            }
                          })
                        ],
                        1
                      )
                    ]
                  : _c(
                      "li",
                      { staticClass: "form__item" },
                      [
                        _c("v-textfield-public", {
                          attrs: {
                            label: _vm.companyLegalForm,
                            name: _vm.companyLegalFormInput
                          },
                          model: {
                            value: _vm.company_legal_form_value,
                            callback: function($$v) {
                              _vm.company_legal_form_value = $$v
                            },
                            expression: "company_legal_form_value"
                          }
                        })
                      ],
                      1
                    ),
                _vm._v(" "),
                _c(
                  "li",
                  { staticClass: "form__item" },
                  [
                    _vm.website == "staffhousing"
                      ? _c("v-textfield-public", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "alpha_num_spaces",
                              expression: "`alpha_num_spaces`"
                            }
                          ],
                          attrs: {
                            label: _vm.companyChamberOfCommerceNumber,
                            name: _vm.companyChamberOfCommerceNumberInput
                          },
                          model: {
                            value: _vm.company_chamber_of_commerce_number_value,
                            callback: function($$v) {
                              _vm.company_chamber_of_commerce_number_value = $$v
                            },
                            expression:
                              "company_chamber_of_commerce_number_value"
                          }
                        })
                      : _c("v-textfield-public", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "alpha_num_spaces",
                              expression: "`alpha_num_spaces`"
                            }
                          ],
                          attrs: {
                            label: _vm.companyChamberOfCommerceNumber,
                            name: _vm.companyChamberOfCommerceNumberInput
                          },
                          model: {
                            value: _vm.company_chamber_of_commerce_number_value,
                            callback: function($$v) {
                              _vm.company_chamber_of_commerce_number_value = $$v
                            },
                            expression:
                              "company_chamber_of_commerce_number_value"
                          }
                        })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "li",
                  { staticClass: "form__item" },
                  [
                    _vm.website == "staffhousing"
                      ? _c("v-textfield-public", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "alpha_num_spaces",
                              expression: "`alpha_num_spaces`"
                            }
                          ],
                          attrs: {
                            label: _vm.companyVatNumber,
                            name: _vm.companyVatNumberInput
                          },
                          model: {
                            value: _vm.company_vat_number_value,
                            callback: function($$v) {
                              _vm.company_vat_number_value = $$v
                            },
                            expression: "company_vat_number_value"
                          }
                        })
                      : _c("v-textfield-public", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "alpha_num_spaces",
                              expression: "`alpha_num_spaces`"
                            }
                          ],
                          attrs: {
                            label: _vm.companyVatNumber,
                            name: _vm.companyVatNumberInput
                          },
                          model: {
                            value: _vm.company_vat_number_value,
                            callback: function($$v) {
                              _vm.company_vat_number_value = $$v
                            },
                            expression: "company_vat_number_value"
                          }
                        })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("li", { staticClass: "form__item" }, [
                  _c("div", { staticClass: "form__row" }, [
                    _c(
                      "div",
                      { staticClass: "form__column" },
                      [
                        _c("v-textfield-public", {
                          attrs: {
                            label: _vm.companyPostCode,
                            name: _vm.companyPostCodeInput
                          },
                          on: {
                            blur: function($event) {
                              return _vm.checkPcHnCompany($event)
                            }
                          },
                          model: {
                            value: _vm.company_post_code_value,
                            callback: function($$v) {
                              _vm.company_post_code_value = $$v
                            },
                            expression: "company_post_code_value"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "form__column" },
                      [
                        _c("v-textfield-public", {
                          attrs: {
                            label: _vm.companyHouseNumber,
                            name: _vm.companyHouseNumberInput
                          },
                          on: {
                            blur: function($event) {
                              return _vm.checkPostcodeAddressCompany($event)
                            }
                          },
                          model: {
                            value: _vm.company_house_number_value,
                            callback: function($$v) {
                              _vm.company_house_number_value = $$v
                            },
                            expression: "company_house_number_value"
                          }
                        })
                      ],
                      1
                    )
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "li",
                  { staticClass: "form__item" },
                  [
                    _c("v-textfield-public", {
                      attrs: {
                        label: _vm.companyStreet,
                        name: _vm.companyStreetInput
                      },
                      model: {
                        value: _vm.company_street_value,
                        callback: function($$v) {
                          _vm.company_street_value = $$v
                        },
                        expression: "company_street_value"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "li",
                  { staticClass: "form__item" },
                  [
                    _c("v-textfield-public", {
                      attrs: {
                        label: _vm.companyCity,
                        name: _vm.companyCityInput
                      },
                      model: {
                        value: _vm.company_city_value,
                        callback: function($$v) {
                          _vm.company_city_value = $$v
                        },
                        expression: "company_city_value"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "li",
                  { staticClass: "form__item" },
                  [
                    _c("v-textfield-public", {
                      attrs: {
                        label: _vm.companyCountry,
                        name: _vm.companyCountryInput
                      },
                      model: {
                        value: _vm.company_country_value,
                        callback: function($$v) {
                          _vm.company_country_value = $$v
                        },
                        expression: "company_country_value"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "li",
                  { staticClass: "form__item" },
                  [
                    _vm.website == "staffhousing"
                      ? _c("v-textfield-public", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required|phone_number",
                              expression: "`required|phone_number`"
                            }
                          ],
                          attrs: {
                            label: _vm.companyPhoneNumber + " (*)",
                            name: _vm.companyPhoneNumberInput
                          },
                          model: {
                            value: _vm.company_phone_number_value,
                            callback: function($$v) {
                              _vm.company_phone_number_value = $$v
                            },
                            expression: "company_phone_number_value"
                          }
                        })
                      : _c("v-textfield-public", {
                          attrs: {
                            label: _vm.companyPhoneNumber,
                            name: _vm.companyPhoneNumberInput
                          },
                          model: {
                            value: _vm.company_phone_number_value,
                            callback: function($$v) {
                              _vm.company_phone_number_value = $$v
                            },
                            expression: "company_phone_number_value"
                          }
                        })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "li",
                  { staticClass: "form__item" },
                  [
                    _vm.website == "staffhousing"
                      ? _c("v-textfield-public", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required|email",
                              expression: "`required|email`"
                            }
                          ],
                          attrs: {
                            label: _vm.companyEmail + " (*)",
                            name: _vm.companyEmailInput
                          },
                          model: {
                            value: _vm.company_email_value,
                            callback: function($$v) {
                              _vm.company_email_value = $$v
                            },
                            expression: "company_email_value"
                          }
                        })
                      : _c("v-textfield-public", {
                          attrs: {
                            label: _vm.companyEmail,
                            name: _vm.companyEmailInput
                          },
                          model: {
                            value: _vm.company_email_value,
                            callback: function($$v) {
                              _vm.company_email_value = $$v
                            },
                            expression: "company_email_value"
                          }
                        })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "li",
                  { staticClass: "form__item" },
                  [
                    _c("v-textfield-public", {
                      attrs: {
                        label: _vm.companyBankAccount,
                        name: _vm.companyBankAccountInput
                      },
                      model: {
                        value: _vm.company_bank_account_value,
                        callback: function($$v) {
                          _vm.company_bank_account_value = $$v
                        },
                        expression: "company_bank_account_value"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "li",
                  { staticClass: "form__item" },
                  [
                    _c("v-textfield-public", {
                      attrs: {
                        label: _vm.companyBic,
                        name: _vm.companyBicInput
                      },
                      model: {
                        value: _vm.company_bic_value,
                        callback: function($$v) {
                          _vm.company_bic_value = $$v
                        },
                        expression: "company_bic_value"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "li",
                  { staticClass: "form__item" },
                  [
                    _c("v-textfield-public", {
                      attrs: {
                        label: _vm.companyInvoiceEmail,
                        name: _vm.companyInvoiceEmailInput
                      },
                      model: {
                        value: _vm.company_invoice_email_value,
                        callback: function($$v) {
                          _vm.company_invoice_email_value = $$v
                        },
                        expression: "company_invoice_email_value"
                      }
                    })
                  ],
                  1
                )
              ],
              2
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.website == "athome"
        ? [
            _c("div", { staticClass: "form__heading" }, [
              _c("h2", { staticClass: "form__title" }, [
                _vm._v(_vm._s(_vm.subscriptionsIncome))
              ])
            ]),
            _vm._v(" "),
            _c(
              "ul",
              { staticClass: "form__list" },
              [
                _c(
                  "li",
                  { staticClass: "form__item" },
                  [
                    _c("v-checkboxes-public", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required|make_choice",
                          expression: "`required|make_choice`"
                        }
                      ],
                      attrs: {
                        label: _vm.subscriptionsIAm,
                        name: _vm.subscriptionsTypeOfIncomeInput,
                        options: _vm.subscriptionsTypeOfIncomeOptions,
                        values: _vm.subscriptions_type_of_income_value
                      },
                      on: { input: _vm.triggerIncomeAdditionalForms }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.income_form_work_business
                  ? [
                      _vm.income_form_work
                        ? _c(
                            "li",
                            { staticClass: "form__item" },
                            [
                              _c("v-radios-public", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required|make_choice",
                                    expression: "`required|make_choice`"
                                  }
                                ],
                                attrs: {
                                  label: _vm.usersContractType,
                                  name: _vm.usersContractTypeInput,
                                  options: _vm.usersContractTypeOptions,
                                  value: _vm.usersContractTypeValue
                                },
                                on: { input: _vm.triggerContractDuration }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showDuration && _vm.income_form_work
                        ? [
                            _c(
                              "li",
                              { staticClass: "form__item" },
                              [
                                _c("v-textfield-public", {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: "required|numeric",
                                      expression: "`required|numeric`"
                                    }
                                  ],
                                  attrs: {
                                    label: _vm.usersContractDuration,
                                    name: _vm.usersContractDurationInput,
                                    value: _vm.usersContractDurationValue
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "li",
                              { staticClass: "form__item" },
                              [
                                _c("v-datepicker-public", {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: "required",
                                      expression: "`required`"
                                    }
                                  ],
                                  attrs: {
                                    label: _vm.usersContractEndDate,
                                    name: _vm.usersContractEndDateInput,
                                    value: _vm.usersContractEndDateValue
                                  }
                                })
                              ],
                              1
                            )
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "li",
                        { staticClass: "form__item" },
                        [
                          _c("v-textfield-public", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "`required`"
                              }
                            ],
                            attrs: {
                              label: _vm.usersOccupation,
                              name: _vm.usersOccupationInput
                            },
                            model: {
                              value: _vm.users_occupation_value,
                              callback: function($$v) {
                                _vm.users_occupation_value = $$v
                              },
                              expression: "users_occupation_value"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "li",
                        { staticClass: "form__item" },
                        [
                          _c("v-textfield-public", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required|numeric",
                                expression: "`required|numeric`"
                              }
                            ],
                            attrs: {
                              label: _vm.usersMonthlyIncome,
                              name: _vm.usersMonthlyIncomeInput
                            },
                            model: {
                              value: _vm.users_monthly_income_value,
                              callback: function($$v) {
                                _vm.users_monthly_income_value = $$v
                              },
                              expression: "users_monthly_income_value"
                            }
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "form__bottom-row" }, [
                            _vm._v(_vm._s(_vm.usersMonthlyIncomeNote))
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "li",
                        { staticClass: "form__item" },
                        [
                          _c("v-radios-public", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "make_choice",
                                expression: "`make_choice`"
                              }
                            ],
                            attrs: {
                              label: _vm.usersDoYouHaveGuarantorGeneral,
                              name: _vm.usersDoYouHaveGuarantorInput,
                              options: _vm.usersDoYouHaveGuarantorOptions,
                              value: _vm.users_do_you_have_guarantor_value
                            },
                            on: { input: _vm.triggerGuarantorForm }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.guarantor_form_state == 1
                        ? _c(
                            "li",
                            { staticClass: "form__item" },
                            [
                              _c("v-textfield-public", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "numeric",
                                    expression: "`numeric`"
                                  }
                                ],
                                attrs: {
                                  label: _vm.usersGuarantorIncome,
                                  name: _vm.usersGuarantorIncomeInput
                                },
                                model: {
                                  value: _vm.users_guarantor_income_value,
                                  callback: function($$v) {
                                    _vm.users_guarantor_income_value = $$v
                                  },
                                  expression: "users_guarantor_income_value"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _vm.income_form_studying
                  ? [
                      !_vm.income_form_work_business
                        ? [
                            _c(
                              "li",
                              { staticClass: "form__item" },
                              [
                                _c("v-radios-public", {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: "required|make_choice",
                                      expression: "`required|make_choice`"
                                    }
                                  ],
                                  attrs: {
                                    label: _vm.usersDoYouHaveGuarantor,
                                    name: _vm.usersDoYouHaveGuarantorInput,
                                    options: _vm.usersDoYouHaveGuarantorOptions,
                                    value: _vm.users_do_you_have_guarantor_value
                                  },
                                  on: { input: _vm.triggerGuarantorForm }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.guarantor_form_state == 1
                              ? _c(
                                  "li",
                                  { staticClass: "form__item" },
                                  [
                                    _c("v-textfield-public", {
                                      directives: [
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                          value: "required|numeric",
                                          expression: "`required|numeric`"
                                        }
                                      ],
                                      attrs: {
                                        label: _vm.usersGuarantorIncome,
                                        name: _vm.usersGuarantorIncomeInput
                                      },
                                      model: {
                                        value: _vm.users_guarantor_income_value,
                                        callback: function($$v) {
                                          _vm.users_guarantor_income_value = $$v
                                        },
                                        expression:
                                          "users_guarantor_income_value"
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e()
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "li",
                        { staticClass: "form__item" },
                        [
                          _c("v-textfield-public", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "`required`"
                              }
                            ],
                            attrs: {
                              label: _vm.usersStudy,
                              name: _vm.usersStudyInput
                            },
                            model: {
                              value: _vm.users_study_value,
                              callback: function($$v) {
                                _vm.users_study_value = $$v
                              },
                              expression: "users_study_value"
                            }
                          })
                        ],
                        1
                      )
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _vm.income_form_any
                  ? _c(
                      "li",
                      { staticClass: "form__item form__item--align-start" },
                      [
                        _c("label", { staticClass: "form__label" }, [
                          _vm._v(_vm._s(_vm.usersExtraInformationIncome))
                        ]),
                        _vm._v(" "),
                        _c("textarea", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.usersIncomeNote,
                              expression: "usersIncomeNote"
                            }
                          ],
                          staticClass: "form__textarea",
                          attrs: { name: _vm.usersExtraInformationIncomeInput },
                          domProps: { value: _vm.usersIncomeNote },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.usersIncomeNote = $event.target.value
                            }
                          }
                        })
                      ]
                    )
                  : _vm._e()
              ],
              2
            )
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.website !== "staffhousing"
        ? _c("div", { staticClass: "form__heading" }, [
            _c("h2", { staticClass: "form__title" }, [
              _vm._v(_vm._s(_vm.usersLandlordDetails))
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.website !== "staffhousing"
        ? _c("ul", { staticClass: "form__list" }, [
            _c(
              "li",
              { staticClass: "form__item" },
              [
                _c("v-radios-public", {
                  attrs: {
                    label: _vm.usersLandlordLabel,
                    name: _vm.usersLandlordRadio,
                    options: _vm.usersLandlordOptions
                  },
                  on: { input: _vm.triggerLandlordType },
                  model: {
                    value: _vm.landlord_type_state,
                    callback: function($$v) {
                      _vm.landlord_type_state = $$v
                    },
                    expression: "landlord_type_state"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _vm.landlord_type_state == "renting_property"
              ? _c("li", { staticClass: "form__item" }, [
                  _c("ul", { staticClass: "form__list" }, [
                    _c(
                      "li",
                      { staticClass: "form__item" },
                      [
                        _c("v-textfield-public", {
                          attrs: {
                            label: _vm.usersLandlordNameLabel,
                            name: _vm.usersLandlordName
                          },
                          model: {
                            value: _vm.users_landlord_name_value,
                            callback: function($$v) {
                              _vm.users_landlord_name_value = $$v
                            },
                            expression: "users_landlord_name_value"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "li",
                      { staticClass: "form__item" },
                      [
                        _c("v-textfield-public", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "email",
                              expression: "`email`"
                            }
                          ],
                          attrs: {
                            label: _vm.usersLandlordEmailLabel,
                            name: _vm.usersLandlordEmail
                          },
                          model: {
                            value: _vm.users_landlord_email_value,
                            callback: function($$v) {
                              _vm.users_landlord_email_value = $$v
                            },
                            expression: "users_landlord_email_value"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "li",
                      { staticClass: "form__item" },
                      [
                        _c("v-textfield-public", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "phone_number",
                              expression: "`phone_number`"
                            }
                          ],
                          attrs: {
                            label: _vm.usersLandlordPhoneLabel,
                            name: _vm.usersLandlordPhone
                          },
                          model: {
                            value: _vm.users_landlord_phone_value,
                            callback: function($$v) {
                              _vm.users_landlord_phone_value = $$v
                            },
                            expression: "users_landlord_phone_value"
                          }
                        })
                      ],
                      1
                    )
                  ])
                ])
              : _vm._e()
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.website !== "staffhousing"
        ? _c("div", { staticClass: "form__heading" }, [
            _c("h2", { staticClass: "form__title" }, [
              _vm._v(_vm._s(_vm.subscriptionsYourDetails))
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.website !== "staffhousing"
        ? _c(
            "ul",
            { staticClass: "form__list" },
            [
              _c(
                "li",
                { staticClass: "form__item form__item--no-label" },
                [
                  _c("v-radios-public", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required|make_choice",
                        expression: "`required|make_choice`"
                      }
                    ],
                    attrs: {
                      name: _vm.subscriptionsSexInput,
                      options: _vm.subscriptionsSexOptions,
                      value: _vm.subscriptions_sex_value
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                { staticClass: "form__item" },
                [
                  _c("v-radios-public", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "`required`"
                      }
                    ],
                    attrs: {
                      label:
                        _vm.locales &&
                        _vm.locales.users &&
                        _vm.locales.users.language,
                      value: _vm.defaultLanguage,
                      name: "languageInput",
                      "show-zero-option": "0",
                      options: _vm.languages
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                { staticClass: "form__item" },
                [
                  _c("v-textfield-public", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required|alpha_spaces_dash",
                        expression: "`required|alpha_spaces_dash`"
                      }
                    ],
                    attrs: {
                      label: _vm.subscriptionsFirstName,
                      name: _vm.subscriptionsFirstNameInput
                    },
                    model: {
                      value: _vm.subscriptions_first_name_value,
                      callback: function($$v) {
                        _vm.subscriptions_first_name_value = $$v
                      },
                      expression: "subscriptions_first_name_value"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                { staticClass: "form__item" },
                [
                  _c("v-textfield-public", {
                    attrs: {
                      label: _vm.subscriptionsMiddleName,
                      name: _vm.subscriptionsMiddleNameInput
                    },
                    model: {
                      value: _vm.subscriptions_middle_name_value,
                      callback: function($$v) {
                        _vm.subscriptions_middle_name_value = $$v
                      },
                      expression: "subscriptions_middle_name_value"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                { staticClass: "form__item" },
                [
                  _c("v-textfield-public", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required|alpha_spaces_dash",
                        expression: "`required|alpha_spaces_dash`"
                      }
                    ],
                    attrs: {
                      label: _vm.subscriptionsLastName,
                      name: _vm.subscriptionsLastNameInput
                    },
                    model: {
                      value: _vm.subscriptions_last_name_value,
                      callback: function($$v) {
                        _vm.subscriptions_last_name_value = $$v
                      },
                      expression: "subscriptions_last_name_value"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                { staticClass: "form__item" },
                [
                  _c("v-textfield-public", {
                    staticClass: "js-postcode",
                    attrs: {
                      name: _vm.subscriptionsPostCode,
                      label:
                        _vm.locales &&
                        _vm.locales.users &&
                        _vm.locales.users.post_code
                    },
                    on: {
                      blur: function($event) {
                        return _vm.checkPcHn($event)
                      }
                    },
                    model: {
                      value: _vm.subscriptions_post_code_value,
                      callback: function($$v) {
                        _vm.subscriptions_post_code_value = $$v
                      },
                      expression: "subscriptions_post_code_value"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                { staticClass: "form__item" },
                [
                  _c("v-textfield-public", {
                    staticClass: "js-house-number",
                    attrs: {
                      name: _vm.subscriptionsHouseNumber,
                      label:
                        _vm.locales &&
                        _vm.locales.users &&
                        _vm.locales.users.house_number
                    },
                    on: {
                      blur: function($event) {
                        return _vm.checkPostcodeAddress($event)
                      }
                    },
                    model: {
                      value: _vm.subscriptions_house_number_value,
                      callback: function($$v) {
                        _vm.subscriptions_house_number_value = $$v
                      },
                      expression: "subscriptions_house_number_value"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                { staticClass: "form__item" },
                [
                  _c("v-textfield-public", {
                    attrs: {
                      name: _vm.subscriptionsStreet,
                      label:
                        _vm.locales &&
                        _vm.locales.users &&
                        _vm.locales.users.street
                    },
                    model: {
                      value: _vm.subscriptions_street_value,
                      callback: function($$v) {
                        _vm.subscriptions_street_value = $$v
                      },
                      expression: "subscriptions_street_value"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                { staticClass: "form__item" },
                [
                  _c("v-textfield-public", {
                    attrs: {
                      "is-update-model": true,
                      name: _vm.subscriptionsCity,
                      label:
                        _vm.locales &&
                        _vm.locales.users &&
                        _vm.locales.users.city
                    },
                    model: {
                      value: _vm.subscriptions_city_value,
                      callback: function($$v) {
                        _vm.subscriptions_city_value = $$v
                      },
                      expression: "subscriptions_city_value"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm.website == "athome"
                ? _c(
                    "li",
                    { staticClass: "form__item" },
                    [
                      _c("v-datepicker-public", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "`required`"
                          }
                        ],
                        attrs: {
                          label: _vm.subscriptionsDateOfBirth,
                          name: _vm.subscriptionsDateOfBirthInput,
                          value: _vm.subscriptions_date_of_birth_value
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "li",
                { staticClass: "form__item" },
                [
                  _c("v-textfield-public", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required|phone_number",
                        expression: "`required|phone_number`"
                      }
                    ],
                    staticClass: "js-unique-phone",
                    attrs: {
                      label: _vm.subscriptionsPhoneNumber,
                      name: _vm.subscriptionsPhoneNumberInput
                    },
                    on: { blur: _vm.checkPhone },
                    model: {
                      value: _vm.subscriptions_phone_number_value,
                      callback: function($$v) {
                        _vm.subscriptions_phone_number_value = $$v
                      },
                      expression: "subscriptions_phone_number_value"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              !!_vm.is_phone_number_unique
                ? _c("li", { staticClass: "form__item" }, [
                    _c("label", { staticClass: "form__label" }),
                    _vm._v(" "),
                    _c("b", { staticStyle: { color: "red" } }, [
                      _vm._v(_vm._s(_vm.phoneNumberAlreadyExists))
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "`required`"
                        }
                      ],
                      attrs: { type: "hidden", name: "phone_number_unique" }
                    })
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "li",
                { staticClass: "form__item" },
                [
                  _c("v-textfield-public", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required|email",
                        expression: "`required|email`"
                      }
                    ],
                    staticClass: "js-unique-mail",
                    attrs: {
                      label: _vm.subscriptionsEmail,
                      name: _vm.subscriptionsEmailInput,
                      type: "email"
                    },
                    on: { blur: _vm.checkMail },
                    model: {
                      value: _vm.subscriptions_email_value,
                      callback: function($$v) {
                        _vm.subscriptions_email_value = $$v
                      },
                      expression: "subscriptions_email_value"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm.is_user_already_exists == 1
                ? _c("li", { staticClass: "form__item" }, [
                    _c("label", { staticClass: "form__label" }),
                    _vm._v(" "),
                    _c("b", { staticStyle: { color: "red" } }, [
                      _vm._v(_vm._s(_vm.isUserAlreadyExists))
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "`required`"
                        }
                      ],
                      attrs: { type: "hidden", name: "user_already_exists" }
                    })
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.is_user_already_exists == 2
                ? _c("li", { staticClass: "form__item" }, [
                    _c("label", { staticClass: "form__label" }),
                    _vm._v(" "),
                    _c("b", { staticStyle: { color: "red" } }, [
                      _vm._v(_vm._s(_vm.isUserBanned))
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "`required`"
                        }
                      ],
                      attrs: { type: "hidden", name: "user_already_exists" }
                    })
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "li",
                { staticClass: "form__item" },
                [
                  _c("v-textfield-public", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "email",
                        expression: "`email`"
                      }
                    ],
                    attrs: {
                      label: _vm.subscriptionsInvoiceEmail,
                      name: _vm.subscriptionsInvoiceEmailInput,
                      type: "email"
                    },
                    model: {
                      value: _vm.subscriptions_invoice_email_value,
                      callback: function($$v) {
                        _vm.subscriptions_invoice_email_value = $$v
                      },
                      expression: "subscriptions_invoice_email_value"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                { staticClass: "form__item" },
                [
                  _c("v-textfield-public", {
                    attrs: {
                      label: _vm.subscriptionsBankAccount,
                      name: _vm.subscriptionsBankAccountInput
                    },
                    model: {
                      value: _vm.subscriptions_bank_account_value,
                      callback: function($$v) {
                        _vm.subscriptions_bank_account_value = $$v
                      },
                      expression: "subscriptions_bank_account_value"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                { staticClass: "form__item" },
                [
                  _c("v-textfield-public", {
                    attrs: {
                      label: _vm.subscriptionsBic,
                      name: _vm.subscriptionsBicInput
                    },
                    model: {
                      value: _vm.subscriptions_bic_value,
                      callback: function($$v) {
                        _vm.subscriptions_bic_value = $$v
                      },
                      expression: "subscriptions_bic_value"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm.website == "athome"
                ? [
                    _c(
                      "li",
                      { staticClass: "form__item" },
                      [
                        _c("v-select-public", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "`required`"
                            }
                          ],
                          attrs: {
                            label: _vm.subscriptionsCivilState,
                            value: _vm.subscriptions_civil_state_value,
                            name: _vm.subscriptionsCivilStateInput,
                            "show-zero-option": "0",
                            options: _vm.subscriptionsCivilStateOptions
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "li",
                      { staticClass: "form__item" },
                      [
                        _c("v-select-public", {
                          attrs: {
                            label: _vm.subscriptionsSmoking,
                            value: _vm.subscriptions_smoking_value,
                            name: "smoking",
                            options: _vm.subscriptionsSmokingOptions,
                            "show-zero-option": "0"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "li",
                      { staticClass: "form__item" },
                      [
                        _c("v-select-public", {
                          attrs: {
                            label: _vm.subscriptionsPets,
                            value: _vm.subscriptions_pets_value,
                            name: "have_pets",
                            options: _vm.subscriptionsPetsOptions,
                            "show-zero-option": "0"
                          },
                          on: { input: _vm.triggerPetsForm }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.subscriptions_pets_value == 1
                      ? _c(
                          "li",
                          { staticClass: "form__item" },
                          [
                            _c("v-textfield-public", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "`required`"
                                }
                              ],
                              attrs: {
                                label: _vm.subscriptionsPetsNote,
                                name: "pets_note"
                              },
                              model: {
                                value: _vm.subscriptions_pets_note_value,
                                callback: function($$v) {
                                  _vm.subscriptions_pets_note_value = $$v
                                },
                                expression: "subscriptions_pets_note_value"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "li",
                      { staticClass: "form__item" },
                      [
                        _c("v-select-public", {
                          attrs: {
                            label: _vm.subscriptionsChildren,
                            value: _vm.subscriptions_children_value,
                            name: "have_children",
                            options: _vm.subscriptionsChildrenOptions,
                            "show-zero-option": "0"
                          },
                          on: { input: _vm.triggerChildrenForm }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.subscriptions_children_value == 1
                      ? _c(
                          "li",
                          { staticClass: "form__item" },
                          [
                            _c("v-textfield-public", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "`required`"
                                }
                              ],
                              attrs: {
                                label: _vm.subscriptionsNumberOfChildren,
                                name: "number_of_children",
                                type: "number"
                              },
                              model: {
                                value:
                                  _vm.subscriptions_number_of_children_value,
                                callback: function($$v) {
                                  _vm.subscriptions_number_of_children_value = $$v
                                },
                                expression:
                                  "subscriptions_number_of_children_value"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "li",
                      { staticClass: "form__item" },
                      [
                        _c("v-textfield-public", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required|numeric|min_value:0|max_value:5",
                              expression:
                                "`required|numeric|min_value:0|max_value:5`"
                            }
                          ],
                          attrs: {
                            label: _vm.subscriptionNumberOfAdults,
                            name: "number_of_adults"
                          },
                          model: {
                            value: _vm.number_of_adults_value,
                            callback: function($$v) {
                              _vm.number_of_adults_value = _vm._n($$v)
                            },
                            expression: "number_of_adults_value"
                          }
                        })
                      ],
                      1
                    )
                  ]
                : _vm._e()
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.number_of_adults_value_computed - 1, function(adult) {
        return _vm.number_of_adults_value > 1 && _vm.website !== "staffhousing"
          ? _c(
              "div",
              { key: adult },
              [
                _c("v-details-inner-form", {
                  attrs: {
                    i: adult - 1,
                    "extra-tenants": _vm.extra_tenants,
                    subscriptions: _vm.innerFormSubscriptions,
                    "users-title-options": _vm.innerFormUsersTitleOptions,
                    "users-first-name": _vm.subscriptionsFirstName,
                    "users-middle-name": _vm.subscriptionsMiddleName,
                    "users-last-name": _vm.subscriptionsLastName,
                    "users-date-of-birth": _vm.subscriptionsDateOfBirth,
                    "users-phone-number": _vm.companyPhoneNumber,
                    "users-email": _vm.subscriptionsEmail,
                    "users-invoice-email": _vm.subscriptionsInvoiceEmail,
                    "users-bank-account": _vm.subscriptionsBankAccount,
                    "users-bic": _vm.subscriptionsBic,
                    "users-civil-state": _vm.subscriptionsCivilState,
                    "users-civil-state-options":
                      _vm.subscriptionsCivilStateOptions,
                    "users-i-am": _vm.subscriptionsIAm,
                    "users-type-of-income-options":
                      _vm.subscriptionsTypeOfIncomeOptions,
                    "users-type-of-income-slugs":
                      _vm.subscriptionsTypeOfIncomeSlugs,
                    "users-contract-type": _vm.usersContractType,
                    "users-contract-type-options": _vm.usersContractTypeOptions,
                    "users-contract-type-attributes":
                      _vm.usersContractTypeAttributes,
                    "users-contract-duration": _vm.usersContractDuration,
                    "users-contract-end-date": _vm.usersContractEndDate,
                    "users-occupation": _vm.usersOccupation,
                    "users-monthly-income": _vm.usersMonthlyIncome,
                    "users-monthly-income-note": _vm.usersMonthlyIncomeNote,
                    "users-do-you-have-guarantor-general":
                      _vm.usersDoYouHaveGuarantorGeneral,
                    "users-do-you-have-guarantor-options":
                      _vm.usersDoYouHaveGuarantorOptions,
                    "users-do-you-have-other-guarantee-options":
                      _vm.usersDoYouHaveOtherGuaranteeOptions,
                    "users-do-you-have-other-guarantee-options-options":
                      _vm.usersDoYouHaveOtherGuaranteeOptionsOptions,
                    "users-guarantor-income": _vm.usersGuarantorIncome,
                    "users-study": _vm.usersStudy,
                    "users-extra-information-income":
                      _vm.usersExtraInformationIncome,
                    "income-form-all-states": _vm.incomeFormAllStates,
                    "income-title": _vm.subscriptionsIncome,
                    "users-landlord-options": _vm.usersLandlordOptions,
                    "is-user-already-exists": _vm.isUserAlreadyExists,
                    "is-user-banned": _vm.isUserBanned,
                    "income-phone-number-already-exists":
                      _vm.phoneNumberAlreadyExists,
                    languages: _vm.languages
                  }
                })
              ],
              1
            )
          : _vm._e()
      }),
      _vm._v(" "),
      _c("ul", { staticClass: "form__list" }, [
        _vm.website !== "staffhousing"
          ? _c(
              "li",
              { staticClass: "form__item" },
              [
                _c("input", {
                  attrs: { name: "is_newsletter_subscriber", type: "hidden" }
                }),
                _vm._v(" "),
                _c("v-checkboxes-public", {
                  staticClass: "form__radio",
                  attrs: {
                    label: _vm.subscribeToNewsletter,
                    name: "is_newsletter_subscriber",
                    options: { "1": "" },
                    value: _vm.isNewsletterSubscriberChecked,
                    checked: _vm.isNewsletterSubscriberChecked
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c("li", { staticClass: "form__item" }, [
          _c(
            "button",
            {
              staticClass: "form__button",
              attrs: { type: "submit" },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.submitForm.apply(null, arguments)
                }
              }
            },
            [_vm._v("\n          " + _vm._s(_vm.commonSend) + "\n        ")]
          )
        ])
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4d8d350a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d8d350a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/admin/components/VDetailsForm.vue
// module id = 423
// module chunks = 1